const rankings = [
  { rank: 1, title: '《庆余年》第二季', heat: '982W', tag: '古装权谋', trend: 'up' },
  { rank: 2, title: '《繁花》', heat: '876W', tag: '年代商战', trend: 'stable' },
  { rank: 3, title: '《狂飙》', heat: '754W', tag: '刑侦扫黑', trend: 'up' },
  { rank: 4, title: '《奔跑吧》最新季', heat: '698W', tag: '户外综艺', trend: 'up' },
  { rank: 5, title: '《长安十二时辰》第二季', heat: '621W', tag: '古装悬疑', trend: 'new' },
  { rank: 6, title: '《三体》', heat: '589W', tag: '科幻巨制', trend: 'stable' },
  { rank: 7, title: '《咒术回战》第二季', heat: '547W', tag: '热血日漫', trend: 'up' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[900px] mx-auto">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 text-center mb-2">热播榜单</h2>
        <p className="text-sm text-foreground-400 text-center mb-8 md:mb-10">全网热度实时排行，热门内容一目了然</p>
        <div className="bg-background-100 rounded-xl overflow-hidden">
          <div className="px-4 md:px-6 py-3 border-b border-background-200 flex items-center gap-3">
            <span className="w-8 text-xs font-medium text-foreground-400 text-center">排名</span>
            <span className="flex-1 text-xs font-medium text-foreground-400">作品名称</span>
            <span className="w-16 text-xs font-medium text-foreground-400 text-center hidden sm:block">类型</span>
            <span className="w-20 text-xs font-medium text-foreground-400 text-right">热度</span>
          </div>
          {rankings.map((item) => (
            <a
              key={item.rank}
              href="#cards"
              className="flex items-center gap-3 px-4 md:px-6 py-3.5 border-b border-background-200/70 last:border-0 hover:bg-background-200/50 transition-colors cursor-pointer"
            >
              <span className="w-8 text-center flex-shrink-0">
                {item.rank <= 3 ? (
                  <span className={`inline-flex w-6 h-6 rounded-full items-center justify-center text-xs font-bold ${
                    item.rank === 1 ? 'bg-primary-500 text-background-50' :
                    item.rank === 2 ? 'bg-accent-500 text-background-50' :
                    'bg-secondary-500 text-background-50'
                  }`}>
                    {item.rank}
                  </span>
                ) : (
                  <span className="text-sm font-medium text-foreground-400">{item.rank}</span>
                )}
              </span>
              <span className="flex-1 text-sm font-medium text-foreground-900 whitespace-nowrap truncate">{item.title}</span>
              <span className="w-16 text-xs text-foreground-500 text-center hidden sm:block">{item.tag}</span>
              <span className="w-20 text-right flex items-center justify-end gap-1.5">
                {item.trend === 'up' && <i className="ri-arrow-up-line text-primary-500 text-xs"></i>}
                {item.trend === 'new' && <i className="ri-sparkling-line text-accent-500 text-xs"></i>}
                {item.trend === 'stable' && <span className="w-3"></span>}
                <span className="text-sm font-semibold text-primary-600">{item.heat}</span>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}